<template>
  <a
    class="suggestion-certificate"
    :href="url"
    rel="noopener nofollow"
    target="_blank"
  >
    <base-icon name="doc-solid" width="16" height="16" />
    Сертификат
  </a>
</template>

<script>
import BaseIcon from "@/components/shared/BaseIcon";

export default {
  components: {
    BaseIcon,
  },
  props: {
    url: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.suggestion-certificate {
  align-items: center;
  display: inline-flex;
  gap: 4px;
  white-space: nowrap;

  .icon {
    flex-shrink: 0;
  }
}
</style>
